import React from 'react';
import { motion } from 'framer-motion';
import '../../assets/styles/CallToActionSection.css';

const CallToActionSection = () => (
  <motion.section
    id="cta"
    className="cta-section section dark"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: 'easeOut' }}
    viewport={{ once: true, amount: 0.3 }}
  >
    <div className="section-inner narrow centered">
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Ready to elevate your business?
      </motion.h2>
      <motion.p
        className="body-lora"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        viewport={{ once: true }}
      >
        Get in touch and schedule a free consultation.
      </motion.p>
      <motion.a
        href="/get-started"
        className="btn-accent"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true }}
      >
        Get started
      </motion.a>
    </div>
  </motion.section>
);

export default CallToActionSection;
